import React from "react"
import { Card } from "../ui/card"
import { Link, useLocation } from "react-router-dom"
import { Zap } from "lucide-react"
import { ScrollReveal } from "../ui/scroll-reveal"
import { createServiceButton, createNavigationButton, createEngagementButton } from "../../lib/analytics-factory"

export function KickstarterCallout() {
  const location = useLocation();
  const pageName = location.pathname === "/" ? "home" : location.pathname.replace(/^\/|\/$/g, '').replace(/\//g, '_');

  // These variables make it easy to adjust the logo positioning and appearance
  const logoStyles = {
    // Adjust these values to change the logo position and size
    scale: 0.6,            // Controls how zoomed in the logo appears (higher = more zoomed in)
    opacity: 0.35,         // Controls the transparency (0.0 to 1.0)
    positionX: 0,          // Controls horizontal position (negative = left, positive = right)
    positionY: 0,          // Controls vertical position (negative = up, positive = down)
  }

  return (
    <section className="relative py-12 scroll-mt-20">
      <div className="container relative">
        <ScrollReveal>
          <Card className="bg-primary/5 border-primary/10 overflow-hidden">
            <div className="grid md:grid-cols-3 items-center">
              <div className="p-8 md:p-10 md:col-span-2 space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
                    <Zap className="w-6 h-6 text-primary" strokeWidth={1.5} />
                  </div>
                  <h2 className="text-2xl font-semibold tracking-tight">
                    AI Kickstarter
                  </h2>
                </div>
                <p className="text-lg text-muted-foreground">
                  A fully trained Partner AI in 8 weeks. We focus on one area of your business, build the Knowledge Architecture and deploy AI that proves value before you commit to more.
                </p>
                {createEngagementButton(
                  <>Explore the AI Kickstarter →</>,
                  `engagement_${pageName}_explore_ai_kickstarter`,
                  {
                    to: "/services/ai-kickstarter",
                    size: "lg",
                    className: "mt-4"
                  }
                )}
              </div>
              <div className="hidden md:block h-full bg-primary/5 relative overflow-hidden" style={{ minHeight: "240px" }}>
                <div className="absolute inset-0 bg-gradient-to-r from-primary/5 to-transparent z-10" />
                <div 
                  className="absolute inset-0" 
                  style={{
                    overflow: "hidden"
                  }}
                >
                  <img 
                    src="/images/logo.svg" 
                    alt="Syllepsis Logo" 
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: `translate(calc(-50% + ${logoStyles.positionX}px), calc(-50% + ${logoStyles.positionY}px)) scale(${logoStyles.scale})`,
                      opacity: logoStyles.opacity,
                      maxWidth: "none",
                      pointerEvents: "none" // Ensures the image doesn't interfere with interactions
                    }}
                  />
                </div>
              </div>
            </div>
          </Card>
        </ScrollReveal>
      </div>
    </section>
  )
} 